/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import  Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import  Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import {
    object, shape, string, arrayOf,
} from 'prop-types';
import { Link } from 'react-router-dom';
import { uid } from 'react-uid';
import { trackData } from '../../../../helpers/tracking/common/commonTrackingHelpers';

const styles = (theme) => ({
    container: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downSmall,
            margin: '0 auto',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downMedium,
            margin: '0 auto',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '1440px',
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '980px',
            margin: '0 auto',
        },
    },
    productContentWrapper: {
        '& p': {
            lineHeight: '1.4',
        },
    },
    productName: {
        fontFamily: 'arial',
        fontSize: '11px',
        color: theme.palette.sympathyProductNameColor,
        textAlign: 'left',
    },
    productPrice: {
        fontSize: '11px',
        color: theme.palette.sympathyProductNameColor,
        textAlign: 'left',
    },
    imageCard: {
        width: '100%',
        marginBottom: 8,
        borderRadius: 0,
        position: ' relative',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
    },
    productImage: {
        display: 'block',
        width: 'inherit',
    },
    productLink: {
        display: 'inline-block',
        textDecoration: 'none',
        color: theme.palette.colorIconHeader,
        maxWidth: '217px',
        margin: '0 10px 30px',
        [theme.breakpoints.down(600)]: {
            maxWidth: '50%',
            padding: '0 10px 30px',
            margin: '0',
        },
    },
    deliveryOption: {
        textDecoration: 'none',
        color: theme.palette.sympathyAdvisorsTitle,
        fontFamily: 'arial',
        fontSize: '11px',
        textAlign: 'left',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    headingLink: {
        color: theme.palette.white,
        textDecoration: 'none',
        textAlign: 'center',
        display: 'block',
        width: 'calc(100% - 114px)',
        float: 'left',
        fontSize: '20px',
        background: theme.palette.cms?.primary || theme.palette.colorPrimary,
        padding: '10px 0',
        [theme.breakpoints.down(600)]: {
            padding: '11px 0',
            fontSize: '15px',
        },
    },
    headingViewAll: {
        width: '114px',
        float: 'left',
        fontSize: '18px',
        borderLeft: `1px solid ${theme.palette.sympathyViewAllBorder}`,
        background: theme.palette.sympathyViewAllBg,
        color: theme.palette.white,
        textDecoration: 'none',
        textAlign: 'center',
        display: 'block',
        padding: '11.3px 0',
        '& img': {
            marginLeft: '5px',
        },
        [theme.breakpoints.down(600)]: {
            padding: '11px 0',
            fontSize: '15px',
        },
    },
    headingBlock: {
        margin: '5px 0 15px',
        display: 'inline-block',
        width: 'calc(100% - 20px)',
    },
    productSection: {
        width: '100%',
        maxWidth: '50%',
        [theme.breakpoints.down(600)]: {
            maxWidth: '100%',
            textAlign: 'center',
        },
    },
    flowerArrange: {
        maxWidth: '100%',
        textAlign: 'center',
    },
    box: {
        background: theme.palette.sympathyAdvisorsBg,
        height: 276,
        width: 979,
        margin: '30px 0',
        borderRadius: 2,
        border: `1px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        [theme.breakpoints.down(600)]: {
            height: '300px',
            position: 'relative',
            width: '100%',
            margin: '30px 10px',
            textAlign: 'center',
        },
        [theme.breakpoints.down(425)]: {
            height: '320px',
        },
    },
    advisorTitle: {
        fontSize: 20,
        height: 'auto',
        float: 'left',
        color: theme.palette.sympathyAdvisorsTitleColor,
        margin: '20px 0 0 20px',
        [theme.breakpoints.down(600)]: {
            fontSize: '23px',
            textAlign: 'center',
            float: 'none',
            margin: '20px 0 0',
        },
    },
    services: {
        minHeight: 150,
        borderRight: `1px solid ${theme.palette.sympathyAdvisorsBorder}`,
        height: 'auto',
        marginTop: 15,
        [theme.breakpoints.down(600)]: {
            borderRight: 'none',
            minHeight: 'auto',
            marginTop: '0',
        },
    },
    serviceLink: {
        color: theme.palette.sympathyCallTitleColor,
        fontSize: '14px',
        float: 'left',
        padding: '10px 10px 0 25px',
        display: 'block',
        width: '100%',
        '&:hover': {
            curser: 'pointer',
            textDecoration: 'none',
        },
        [theme.breakpoints.down(600)]: {
            width: '100%',
        },
    },
    callTitle: {
        fontSize: '20px',
        height: 'auto',
        color: theme.palette.sympathyCallTitleColor,
        fontWeight: 'bold',
        padding: '10px 10px 0 25px',
        position: 'absolute',
        bottom: '0px',
        [theme.breakpoints.down(600)]: {
            right: 0,
            left: 0,
        },
    },
    videoBox: {
        width: 235,
        height: 157,
        display: 'inline-block',
        background: theme.palette.colorIconHeader,
        marginLeft: 50,
        marginTop: 15,
    },
    sniperCorner: {
        position: 'absolute',
        bottom: 0,
    },
    hideBorderRight: {
        borderRight: 'none',
        [theme.breakpoints.up(600)]: {
            position: 'relative',
        },
    },
});
const headerSection = (classes, title, url, arrowSignImage) => (
    <div key={uid(title)} className={classes.headingBlock}>
        <Link className={classes.headingLink} title={title} to={url}>{title}</Link>
        <Link className={classes.headingViewAll} title={`View All ${title}`} to={url}> View All
            <img src={arrowSignImage} alt="" />
        </Link>
    </div>
);

const productList = (classes, List) => (
    List.map((product) => {
        const {
            name, product_url, image: { image_path, altText, image_snipe: { image_path: imageSnipe, altText: altTextSnipe } }, prices: { lower_price, higher_price }, deliveryOption,
        } = product;
        return (
            <Link
                key={uid(product)}
                to={product_url}
                className={classes.productLink}
            >
                <Card className={classes.imageCard}>
                    <img
                        src={`${image_path}?height=240&width=219`}
                        alt={altText}
                        className={classes.productImage}
                    />
                    {imageSnipe ? <img src={imageSnipe} className={classes.sniperCorner} alt={altTextSnipe} /> : null}
                </Card>
                <Grid container direction="column" className={classes.productContentWrapper}>
                    <Grid item>
                        <Typography className={classes.productName}>{name}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.productPrice}>
                            {lower_price ? `$${lower_price}` : null}{lower_price && higher_price ? '-' : null}{higher_price ? `$${higher_price}` : null}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.deliveryOption}>{deliveryOption}</Typography>
                    </Grid>
                </Grid>
            </Link>
        );
    })
);
const KosherSympathyBlock = ({ data, classes }) => {
    // Persist data layer
    const {
        arrowSignImage, Food, advisors: { nameAdvisors, serviceList }, flowerArrangements: { title: titleFlower, url: urlFlower, products: productFlower },
    } = data;
    trackData({
        untData: data,
        action: 'track_seo_articles_data',
    });

    return (
        <Grid container className={classes.container}>
            {Food.map((product) => {
                const { title, url } = product;
                return (
                    <div key={uid(product)} className={`${classes.productSection}`}>
                        {headerSection(classes, title, url, arrowSignImage)}
                        <div>
                            {productList(classes, product.products)}
                        </div>
                    </div>
                );
            })}
            <Grid item xs={12}>
                <Grid item xs={12} />
                <div className={classes.flowerArrange}>
                    {headerSection(classes, titleFlower, urlFlower, arrowSignImage)}
                    {productList(classes, productFlower)}
                </div>
                <Grid className={`${classes.productSection}`} item xs={6} />
            </Grid>
            <Grid item xs={12} className={`${classes.box}`}>
                <Typography variant="h3" className={classes.advisorTitle}>{nameAdvisors}</Typography>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <Box className={classes.services}>
                            {
                                serviceList
                                    ? serviceList.map((service, i) => (
                                        i < 5 ? <Link key={uid(service)} to={service.link} className={classes.serviceLink}>{service.serviceName}</Link> : null
                                    ))
                                    : null
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Box className={`${classes.services} ${classes.hideBorderRight}`}>
                            {
                                serviceList
                                    ? serviceList.map((service, i) => (
                                        i >= 5 ? <Link key={uid(service)} to={service.link} className={classes.serviceLink}>{service.serviceName}</Link> : null
                                    ))
                                    : null
                            }
                            <Typography className={classes.callTitle}>Call us at 1-844-314-5781</Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
KosherSympathyBlock.propTypes = {
    classes: object.isRequired,
    data: shape({
        Food: arrayOf(
            shape({
                name: string,
                product_url: string,
                image: shape({
                    image_path: string.isRequired,
                    altText: string.isRequired,
                    image_snipe: shape({
                        image_path: string.isRequired,
                        altText: string.isRequired,
                    }),

                }),
                prices: shape({
                    lower_price: string.isRequired,
                    higher_price: string.isRequired,
                }),
                deliveryOption: string,
            }),
        ),
        arrowSignImage: string.isRequired,
        callUsUrl: string.isRequired,
        advisors: shape({
            nameAdvisors: string.isRequired,
            serviceList: arrayOf(
                shape({
                    link: string.isRequired,
                    serviceName: string.isRequired,
                }),
            ),
        }).isRequired,
        flowerArrangements: shape({
            title: string,
            urlFlower: string,
            products: arrayOf(
                shape({
                    image: shape({
                        image_path: string,
                        altText: string,
                        image_snipe: shape({
                            image_path: string,
                            altText: string,
                        }),
                    }),
                }),
            ),

        }),
    }).isRequired,
};

export default withStyles(styles)(KosherSympathyBlock);
